import { showPageLoader } from './index';
import { logError, logException } from '../services/sentryService';

const submitPlaceOrderForm = () => {
  try {
    showPageLoader();
    $('#js-placeOrderForm').submit();
  } catch (error) {
    logError(
      `Express Checkout with Mobile Apps: Error on placeOrder ${error.message}`
    );
  }
};

function notifyMobileAppOnPreviewPageSuccess() {
  const errorCode = window.expressCheckoutPlaceOrderErrorCode;

  if (errorCode) {
    logError(
      `Express Checkout: error code present on preview page: ${errorCode}`
    );
    return;
  }

  if (typeof window.previewPageSuccess !== 'function') {
    logError(
      'Express Checkout: previewPageSuccess is missing from window object'
    );
    return;
  }

  window.previewPageSuccess();
}

const exposeCallbackFunctionsForMobileApp = () => {
  window.onPayCollected = (paymentMethod, paymentData) => {
    try {
      if (paymentMethod === 'APPLE_PAY') {
        const { payTokenId, paymentPlatformType } = paymentData || {};
        if (!payTokenId || !paymentPlatformType) {
          sendPreviewValidationErrorToMobileApp('INVALID_PAYMENT_DATA', true);
          return;
        }

        $('#js-applePayOrderId').val(payTokenId);
        $('#js-paymentPlatformType').val(paymentPlatformType);
        submitPlaceOrderForm();
      } else {
        logError(
          `Express Checkout with Mobile Apps: Unsupported payment method: ${paymentMethod}`
        );
      }
    } catch (error) {
      logException(
        `Express Checkout with Mobile Apps: Error in onPayCollected ${error.message}`,
        {
          area: 'checkout',
          payment: `Express Checkout with Mobile Apps - ${paymentMethod}`,
        }
      );
    }
  };
};

const handleExpressCheckoutOrderPlacementErrorCodeToMobileApp = () => {
  const errorCode = window.expressCheckoutPlaceOrderErrorCode;

  if (!errorCode) {
    return;
  }

  sendPreviewValidationErrorToMobileApp(
    errorCode,
    window.expressCheckoutIsRetryableError
  );
};

const sendPreviewValidationErrorToMobileApp = (errorCode, isRetryable) => {
  if (typeof window.previewValidationError !== 'function') {
    logError('Mobile bridge function "previewValidationError" is missing.');
    return;
  }

  try {
    window.previewValidationError(errorCode, isRetryable);
  } catch (err) {
    logError(
      `Failed to send express checkout error code to mobile app: ${
        err?.message || err
      }`
    );
  }
};

const getAppExpressCheckoutToggleStatus = () => {
  return typeof window.isExpressCheckoutAppEnabled === 'function'
    ? window.isExpressCheckoutAppEnabled()
    : false;
};

export const ExpressCheckout = {
  init: () => {
    window.isExpressCheckoutOnMobileAppsEnabled =
      getAppExpressCheckoutToggleStatus();

    const { isExpressCheckoutOnMobileAppsEnabled } = window;
    if (!isExpressCheckoutOnMobileAppsEnabled) {
      return;
    }

    const currentUrl = window.location.href.toLowerCase();
    const isPreviewPage = currentUrl.includes('preview');
    const isEditPaymentPage = currentUrl.includes('editpayment');
    const isEditInvoiceAddressPage = currentUrl.includes('editaddress');
    const isEditDeliveryAddressPage = currentUrl.includes(
      'editshippingaddress'
    );

    if (isPreviewPage) {
      exposeCallbackFunctionsForMobileApp();
      notifyMobileAppOnPreviewPageSuccess();
    }

    const isExpressCheckoutTouchPointPages =
      isPreviewPage ||
      isEditPaymentPage ||
      isEditInvoiceAddressPage ||
      isEditDeliveryAddressPage;

    if (isExpressCheckoutTouchPointPages) {
      handleExpressCheckoutOrderPlacementErrorCodeToMobileApp();
    }
  },
};
